import React from 'react'
import { Container, Row } from 'react-bootstrap';
import { data } from '../data';
import { Link } from 'react-router-dom';

const Publications = () => {
    return (<>

        <Container className="outerContainer">
            <h1 className="centerText mb-4">Publications</h1>
            <p className="mb-5">The list below presents selected articles from 2013 through 2017 that focus on the use of AHRQ QIs for quality improvement purposes.

</p>


            {data.Resources.map((information, index) => (
                <div key={index}>
                    {information.publications.map((publication) => (<>
                        <Row className="mb-3 mt-3">
                            <p>{publication.title}</p>

                        </Row>
                        <hr />
                    </>))}
                </div>
            ))}
                        <p>For publications prior to 2013 see the <Link to="/archive/resources?3">Archive Resources page</Link></p>

        </Container>
    </>)
}

export default Publications;